var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "67", height: "50", viewBox: "0 0 67 50" }, props),
    React.createElement("path", { fill: "#E5E5E5", fillRule: "evenodd", d: "M15.88 49.63a16.38 16.38 0 1 1 1-32.75 16.68 16.68 0 0 1 0-.5 16.38 16.38 0 1 1 32.75.5h.5a16.38 16.38 0 0 1 .5 32.75H15.88zm17.7-4.22L45.4 27.46h-7.9V7.9h-7.88v19.56h-7.9l11.84 17.95z" })
  );
});